export interface Language {
  value: string;
  countryCode: string;
  label: string;
}

export const LANGUAGE_CHANGED_CHANNEL = 'radish:language:changed';

export const LANGUAGES: Language[] = [
  { value: 'en', countryCode: 'us', label: 'English' },
  { value: 'de', countryCode: 'de', label: 'Deutsch' },
  { value: 'es', countryCode: 'es', label: 'Español' },
];
